<div
  class="bg-blend-[var(--bg-blend)] flex h-screen flex-col overflow-hidden bg-(--bg-main) bg-[url('/assets/images/bg-landing.png')] bg-size-[80vw] bg-center bg-no-repeat"
>
  @if (!headless()) {
    <re-app-bar class="flex h-12 shrink-0 items-stretch" />
  }
  <nsp-loading-overlay [isLoading]="appStore.isLoadingFullOverlay()" />

  <div class="flex min-h-0 w-full flex-1 overflow-hidden">
    <router-outlet />
  </div>
</div>
<p-toast />
